import { vservice } from '@niknevis/vue-modules'
import { ContentRoutes } from '@/modules/content/routes/content.routes'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'

@vservice()
export class ContentService {
  constructor(
    private readonly routes: ContentRoutes
  ) {
  }

  convertDocxToHtml(file: File) {
    const formData = new FormData()
    formData.append('file', file)

    return HTTP.post(
      this.routes.convertDocxToHtml(),
      formData
    ).then(response => response.json())
  }
}
